import React from "react";
import { getBusinessType, InfoItem, InputField } from "../../../utils/utils";
import { theme } from "../../../utils/theme";

const BusinessDetails = ({
    type = "printShop", // printShop | supplier | specialist
    isEditing,
    form,
    onEdit,
    onCancel,
    onSave,
    onChange,
}) => {
    const t = theme[type];

    return (
        <div
            className="bg-white rounded-[16px] border border-[#e4e5e7] overflow-hidden"
        >
            {/* HEADER */}
            <div
                className="px-[20px] py-[14px] border-b border-[#f0f1f3]"
            >
                <div className="flex items-center justify-between">
                    <p className="font-semibold text-[15px] text-[#212326]">
                        Business Details
                    </p>

                    {!isEditing ? (
                        <button
                            onClick={onEdit}
                            className="px-[14px] py-[7px] rounded-[10px] font-semibold text-[13px] text-white"
                            style={{ backgroundColor: t.primary }}
                        >
                            Edit
                        </button>
                    ) : (
                        <div className="flex items-center gap-[8px]">
                            <button
                                onClick={onCancel}
                                className="px-[14px] py-[7px] rounded-[10px] font-semibold text-[13px]"
                                style={{
                                    backgroundColor: t.accentBg,
                                    color: t.primary,
                                }}
                            >
                                Cancel
                            </button>

                            <button
                                onClick={onSave}
                                className="px-[14px] py-[7px] rounded-[10px] font-semibold text-[13px] text-white"
                                style={{ backgroundColor: t.primary }}
                            >
                                Save
                            </button>
                        </div>
                    )}
                </div>
            </div>

            {/* VIEW MODE */}
            {!isEditing ? (
                <div className="p-[20px]">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-[16px]">
                        <InfoItem label="Business Name" value={form?.shopName} />
                        <InfoItem label="Contact Email" value={form?.email} />
                        <InfoItem label="Phone" value={form?.phone} />
                        <InfoItem label="Business Type" value={getBusinessType(form?.type)} />
                    </div>

                    <div className="mt-[16px]">
                        <p className="font-medium text-[12px] text-[#9298a0] mb-[4px]">
                            Description
                        </p>

                        <p className="font-medium text-[14px] text-[#212326] leading-[1.6]">
                            {form?.description}
                        </p>
                    </div>
                </div>
            ) : (
                /* EDIT MODE */
                <div className="p-[20px]">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-[16px]">

                        <InputField
                            label="Business Name"
                            value={form?.shopName}
                            onChange={(value) => onChange("shopName", value)}
                        />

                        <div>
                            <p className="font-medium text-[12px] text-[#9298a0] mb-[6px]">
                                Email
                            </p>

                            <p className="font-medium text-[14px] text-[#717182] h-[44px] flex items-center">
                                {form?.email}
                                <span className="ml-[6px] text-[11px] text-[#9298a0]">
                                    (cannot be changed)
                                </span>
                            </p>
                        </div>

                        <InputField
                            label="Phone"
                            value={form?.phone}
                            onChange={(value) => onChange("phone", value)}
                        />

                        <div>
                            <p className="font-medium text-[12px] text-[#9298a0] mb-[6px]">
                                Business Type
                            </p>

                            <p className="font-medium text-[14px] text-[#717182] h-[44px] flex items-center">
                                {getBusinessType(form?.type)}
                                <span className="ml-[6px] text-[11px] text-[#9298a0]">
                                    (cannot be changed)
                                </span>
                            </p>
                        </div>
                    </div>

                    <div className="mt-[16px]">
                        <p className="font-medium text-[12px] text-[#9298a0] mb-[6px]">
                            Description
                        </p>

                        <textarea
                            rows={4}
                            value={form?.description}
                            onChange={(e) =>
                                onChange("description", e.target.value)
                            }
                            className="w-full rounded-[10px] border border-[#e4e5e7] px-[14px] py-[10px] font-medium text-[14px] text-[#212326] resize-none focus:outline-none focus:border-[#ff5323]"
                        />
                    </div>
                </div>
            )}
        </div>
    );
};

export default BusinessDetails;